import {Component, OnInit} from '@angular/core';
import {AppService} from '../app.service';

@Component({
  selector: 'app-carousel-clients',
  templateUrl: './carousel-clients.component.html',
  styleUrls: ['./carousel-clients.component.scss']
})
export class CarouselClientsComponent implements OnInit {
  constructor(private appService: AppService) {
  }

  // trustedBusinesses: TrustedBusinesses = new TrustedBusinesses();
  trustedBusinesses: Array<any>;

  ngOnInit() {
    this.businessesCarousel();
  }

  businessesCarousel() {
    this.appService.businessesCarouselContent().then((data) => {
      this.trustedBusinesses = data;
    });
  }
}
